import { TransactionRepeatEnum } from "../../repsaApi";

import api, * as transactionApi from "../transactions/transactionApi";
import {
  agentReferreredError,
  agentReferreredLoaded,
  agentReferreredLoading,
  agentReferrersError,
  agentReferrersLoaded,
  agentReferrersLoading,
  clientRepeatsError,
  clientRepeatsLoaded,
  clientRepeatsLoading,
  selectedTransactionsError,
  selectedTransactionsLoaded,
  selectedTransactionsLoading,
  soiReferrersError,
  soiReferrersLoaded,
  soiReferrersLoading,
  vendorReferrersError,
  vendorReferrersLoaded,
  vendorReferrersLoading,
  combinedRepeatsAndReferrersLoading,
  combinedRepeatsAndReferrersLoaded,
  combinedRepeatsAndReferrersError,
} from "./repeatsAndReferrersStateActions";
// Action creators
export const fetchClientRepeats =
  (coAgentIds?: number[]) => async (dispatch: any) => {
    try {
      dispatch(clientRepeatsLoading());
      const data = await transactionApi.getTransactionRepeatsWithFilter(
        TransactionRepeatEnum.Client,
        coAgentIds,
      );
      dispatch(clientRepeatsLoaded(data));
    } catch (error) {
      dispatch(clientRepeatsError("Failed to fetch client repeats"));
    }
  };

export const fetchSoiReferrers =
  (coAgentIds?: number[]) => async (dispatch: any) => {
    try {
      dispatch(soiReferrersLoading());
      const data = await transactionApi.getTransactionRepeatsWithFilter(
        TransactionRepeatEnum.Soi,
        coAgentIds,
      );
      dispatch(soiReferrersLoaded(data));
    } catch (error) {
      dispatch(soiReferrersError("Failed to fetch SOI referrers"));
    }
  };

export const fetchVendorReferrers =
  (coAgentIds?: number[]) => async (dispatch: any) => {
    try {
      dispatch(vendorReferrersLoading());
      const data = await transactionApi.getTransactionRepeatsWithFilter(
        TransactionRepeatEnum.Vendor,
        coAgentIds,
      );
      dispatch(vendorReferrersLoaded(data));
    } catch (error) {
      dispatch(vendorReferrersError("Failed to fetch vendor referrers"));
    }
  };

export const fetchAgentReferrers =
  (coAgentIds?: number[]) => async (dispatch: any) => {
    try {
      dispatch(agentReferrersLoading());
      const data = await transactionApi.getTransactionRepeatsWithFilter(
        TransactionRepeatEnum.Agent,
        coAgentIds,
      );
      dispatch(agentReferrersLoaded(data));
    } catch (error) {
      dispatch(agentReferrersError("Failed to fetch agent referrers"));
    }
  };

export const fetchAgentseferrered =
  (coAgentIds?: number[]) => async (dispatch: any) => {
    try {
      dispatch(agentReferreredLoading());
      const data = await transactionApi.getTransactionRepeatsWithFilter(
        TransactionRepeatEnum.Referred,
        coAgentIds,
      );
      dispatch(agentReferreredLoaded(data));
    } catch (error) {
      dispatch(agentReferreredError("Failed to fetch agents referred"));
    }
  };
export const fetchClientTransactions =
  (clientId: number) => async (dispatch: any) => {
    try {
      dispatch(selectedTransactionsLoading());
      const data = await api.getTransactionsByEntity(
        TransactionRepeatEnum.Client,
        clientId,
      );
      dispatch(selectedTransactionsLoaded(data));
    } catch (error) {
      dispatch(
        selectedTransactionsError("Failed to fetch client transactions"),
      );
    }
  };

export const fetchReferrerTransactions =
  (referrerId: number, referrerType: "soi" | "vendor" | "agent" | "referred") =>
  async (dispatch: any) => {
    try {
      dispatch(selectedTransactionsLoading());
      let entityType: TransactionRepeatEnum;

      switch (referrerType) {
        case "soi":
          entityType = TransactionRepeatEnum.Soi;
          break;
        case "vendor":
          entityType = TransactionRepeatEnum.Vendor;
          break;
        case "agent":
          entityType = TransactionRepeatEnum.Agent;
          break;
        case "referred":
          entityType = TransactionRepeatEnum.Referred;
          break;
        default:
          throw new Error("Invalid referrer type");
      }

      const data = await api.getTransactionsByEntity(entityType, referrerId);
      dispatch(selectedTransactionsLoaded(data));
    } catch (error) {
      dispatch(
        selectedTransactionsError(
          `Failed to fetch ${referrerType} referrer transactions`,
        ),
      );
    }
  };

export const fetchCombinedRepeatsAndReferrers =
  (coAgentIds?: number[]) => async (dispatch: any) => {
    try {
      dispatch(combinedRepeatsAndReferrersLoading());
      const data = await transactionApi.getTransactionRepeatsWithFilter(
        TransactionRepeatEnum.ClientRepeatsAndReferrers,
        coAgentIds,
      );
      dispatch(combinedRepeatsAndReferrersLoaded(data));
    } catch (error) {
      dispatch(
        combinedRepeatsAndReferrersError(
          "Failed to fetch combined repeats and referrers",
        ),
      );
    }
  };

export const getTransactionsByEntityId =
  (entityId: number, contactTypeId: number | null) => async () => {
    try {
      const data = await api.getTransactionsByEntityName(
        entityId,
        contactTypeId,
      );
      return data;
    } catch (error) {
      throw new Error("Failed to fetch transactions");
    }
  };
